module.exports = __webpack_public_path__ + "static/media/Umrah_insurance.19173c55.svg";